import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SjtGameSelectorComponent } from './sjt-game-selector/sjt-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SjtGameCoreService } from './sjt-game-core.service';

@NgModule({
  declarations: [SjtGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [SjtGameCoreService],
  exports: [SjtGameSelectorComponent],
})
export class SjtGameCoreModule {}
